// extracted by mini-css-extract-plugin
export default {"container":"bdoIZU","group-description":"xIXQSs","groupDescription":"xIXQSs"};